<div class="page-content" *ngIf="!timerService.isForwarding">

       <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>
  
       <h1 class="page-title" translate>{{'setup_1.page_title'}}</h1>
       
       <form>
             <div id="isBornInOntario">
              <ng-radio [(ng-model)]="eligibility.isBornInOntario" id="isBornInOntarioRadio" 
                        [(ng-error)]="error_bornInOntario"
                        [item-list]="items.yesNoList">
                     <h2 translate>{{'setup_1.wasBornInOntario'}}</h2>
              </ng-radio>
            </div>
              <div aria-live='assertive'>
              <notice-box [hidden]="eligibility.isBornInOntario!='N'">
                     <span translate>{{'setup_1.critical-notice1-text1'}}</span>
                            <a href="{{'setup_1.critical-notice1-link'|translate}}" 
                                   title="{{'setup_1.critical-notice1-link-alt'|translate}}" target="_blank">{{'setup_1.critical-notice1-link-label'|translate}}</a>
                     <span translate>{{'setup_1.critical-notice1-text2'}}</span>
              </notice-box>
              </div> <br/>
              
              <birth-day [(ng-model)]="data.aboutChild.birthDay"></birth-day>
              <br/>              
        </form>       
              
        <div class="btn-div" [hidden]="eligibility.isOneYearMore || eligibility.isBornInOntario=='N'">
             <button class="btn-next" title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>{{Button.Next}}</button>
        </div>
       
        <div class="btn-div" [hidden]="!eligibility.isOneYearMore && eligibility.isBornInOntario!='N'">
             <button class="btn-next" title="{{Button.Cancel_alt|translate}}" (click)="onCancelApplication()" translate>{{Button.Cancel}}</button>
        </div>
  </div>